import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { FiltroFundo } from '../model/filtro-fundo';

@Injectable({
  providedIn: 'root'
})
export class MultiplosFiltrosService {

  private isFiltroFundoCriado = new Subject<FiltroFundo>();
  isFiltroFundoCriado$ = this.isFiltroFundoCriado.asObservable();

  private isFiltroFundoRemovido = new Subject<boolean>();
  isFiltroFundoRemovido$ = this.isFiltroFundoRemovido.asObservable();

  constructor() { }

  filtroFundoCriado(filtro: FiltroFundo): void {
    this.isFiltroFundoCriado.next(filtro);
  }

  filtroFundoRemovido(): void {
    this.isFiltroFundoRemovido.next(true);
  }

}
